import { createSlice } from "@reduxjs/toolkit";

export type Policy = {
  id: number;
  policy_number: string;
  client_name: string;
  category: string;
  insurer: string;
  premium: number;
  expires: string;
  status: string;
  issued_by: string;
};

export type PolicyList = {
  total: number;
  page: number;
  page_size: number;
  data: Policy[];
};

export type PolicyState = {
  policyList: PolicyList | null;
  policyStatusOptions: Array<{ label: string; value: string }>;
};

const initialState: PolicyState = { policyList: null, policyStatusOptions: [] };

const policySlice = createSlice({
  name: "policy",
  initialState,
  reducers: {
    policyList: (state, action: { payload: PolicyState["policyList"] }) => {
      state.policyList = action.payload;
    },
    setPolicyStatusList: (state, action) => {
      state.policyStatusOptions = action.payload?.data || action.payload || [];
    },
  },
});

export const { policyList, setPolicyStatusList } = policySlice.actions;
export default policySlice.reducer;
